<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
      id="createModal"
      class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
              type="button"
              class="close"
              data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
              title="Create Admin"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="title">Title</label>
                      <validation-provider
                          #default="{ errors }"
                          name="title"
                          rules="required"
                      >
                        <v-select
                            v-model="createdAdmin.title"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="titles"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="first_name">First Name </label>
                      <validation-provider
                          #default="{ errors }"
                          name="First Name"
                          rules="required"
                      >
                        <b-form-input
                            id="first_name"
                            v-model="createdAdmin.first_name"
                            name="first_name"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="last_name">Last Name</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Last Name"
                          rules="required"
                      >
                        <b-form-input
                            id="last_name"
                            v-model="createdAdmin.last_name"
                            name="last_name"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="phone_number">Phone</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Phone"
                          rules="required"
                      >
                        <b-form-input
                            id="phone_number"
                            v-model="createdAdmin.phone_number"
                            type="number"
                            name="phone_number"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="first_name">Roles</label>
                      <validation-provider
                          #default="{ errors }"
                          name="roles"
                          rules="required"
                      >
                        <v-select
                            name="roles"
                            v-model="assignedRoles.roles"
                            class="parent-service"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="roles"
                            :reduce="name => name.id"
                            label="name"
                            multiple
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!--                  <b-col md="6">-->
                  <!--                    <b-form-group>-->
                  <!--                      <label for="last_name">EID</label>-->
                  <!--                      <validation-provider-->
                  <!--                          #default="{ errors }"-->
                  <!--                          name="EID"-->
                  <!--                          rules="required"-->
                  <!--                      >-->
                  <!--                        <b-form-input-->
                  <!--                            id="eid_number"-->
                  <!--                            v-model="createdAdmin.eid_number"-->
                  <!--                            type="number"-->
                  <!--                            name="eid_number"-->
                  <!--                            :state="errors.length > 0 ? false:null"-->
                  <!--                            placeholder=""-->
                  <!--                        />-->
                  <!--                        <small class="text-danger">{{ errors[0] }}</small>-->
                  <!--                      </validation-provider>-->
                  <!--                    </b-form-group>-->
                  <!--                  </b-col>-->
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="email">Email</label>
                      <validation-provider
                          #default="{ errors }"
                          name="Email"
                          rules="required|email"
                      >
                        <b-form-input
                            id="email"
                            v-model="createdAdmin.email"
                            type="email"
                            name="email"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>

                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import {codeMultiple, codeBasic} from './code'
import FormTextAreaDefault from '../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import clientService from '@/services/clientService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import adminService from '../../../services/adminService'
import representativesService from '@/services/representativesService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      roles: [],
      adminId: '',
      assignedRoles: {roles: []},
      createdAdmin: {
        title: '',
        first_name: '',
        last_name: '',
        phone_number: '',
        password: '',
        // eid_number: '',
        email: ''
      },
      titles: ['Mr.', 'Ms.'],
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      codeBasic,
    }
  },
  mounted() {
    this.getRoles()
    this.$watch(() => this.admin, admin => {
      this.adminId = admin
      console.log(';lllll', this.adminId)
      this.getRolesByAdmin()

    })

  },
  methods: {
    getRoles() {
      this.loading = true
      adminService.index().then(response => {
        this.roles = response.data.data
      })
    },
    getRolesByAdmin() {
      adminService.rolesByAdmin(this.adminId).then(response => {
        this.assignedRoles.roles = response.data && response.data.data.length >= 0  ? response.data.data : []
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              adminService.postAdmin({...this.createdAdmin, roles: this.assignedRoles.roles}).then(response => {
                if (response && response.status === 200) {
                  this.$emit('refresh', 'true')
                  $('#createModal').modal('hide')
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'Admin Is Created Successfully !',
                    },
                  })
                }
                this.loading = false
              })
            }
          }).catch(function (error) {
        console.log('Show error notification!', error)
        $('#createModal').modal('hide')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Success',
            icon: 'CheckIcon',
            variant: 'Error',
            text: 'Error !',
          },
        })
        return Promise.reject(error)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}

#createModal svg {
  filter: invert(69%) sepia(14%) saturate(4763%) hue-rotate(3deg) brightness(100%) contrast(43%) !important;
}
</style>
